import 'babel-polyfill';
import 'core-js/stable';import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './http'
import Print from '@/plugs/print'
import 'mint-ui/lib/style.css'
// import 'video.js/dist/video-js.css'
// import VueVideoPlayer from 'vue-video-player'
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VueVideoPlayer);
Vue.use(Print)
Vue.use(ElementUI);
// import VueCoreVideoPlayer from 'vue-core-video-player'

// Vue.use(VueCoreVideoPlayer, {
//   lang: 'zh-CN'
// })
Vue.prototype.$axios = axios

Vue.config.productionTip = false

//将socket注入到vue原型中
// import {
//   sockBarrage,
//   socketBarrage
// } from "@/socket.js"
// Vue.prototype.$sockBarrage = sockBarrage
// Vue.prototype.$socketBarrage = socketBarrage

const TcPlayer = window.TcPlayer;
Vue.prototype.TcPlayer = TcPlayer
import AudioPlayer from '@liripeng/vue-audio-player'
import '@liripeng/vue-audio-player/lib/vue-audio-player.css'

Vue.use(AudioPlayer)
new Vue({
  router,
  store,
  render: h => h(App),
  //定义用户以购买的课程数据
  data: function () {
    return {
      hasCourse: "",
      ischeckface: false,
      buytype: 0,
      onlymycourse: false,
    }
  }
}).$mount('#app')